import React, { useState } from 'react';
import { Card, CardBody } from 'reactstrap';
import { DoughnutChart } from 'components';

const InfectionsByGender = props => {
    const { view, loaded, query, province } = props;
    const [chartData, setChartData] = useState({});

    const cdata = {
        labels: [
            'Males',
            'Females',
        ],
        datasets: [{
            data: [1234, 736],
            backgroundColor: ['rgba(1,104,250,0.7)'],
        }],
    };

    return (
        <Card>
            <CardBody className="pd-20">
                <h6 className="mg-b-5">Number of infected persons, by gender</h6>
                <div className="pd-y-30">
                    <DoughnutChart chartData={cdata} />
                </div>
            </CardBody>
        </Card>
    );
};

export default InfectionsByGender;
